import { createReducer, on } from '@ngrx/store';
import { setLanguage, setState, setTheme } from './app.actions';
import { IAppState, initialState } from './app.state';

export const appReducer = createReducer<IAppState>(initialState,  
  on(setLanguage, (state, {language}) => ({...state, language})),
  on(setTheme, (state, {theme}) => ({...state, theme})),
  on(setState, (_, {state}) => ({...state}))
);
